function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import RcSlider from 'rc-slider';
import { useMemo } from 'react';
import { handleRender } from "./sliderTooltip";
import { container, markStyle, sizeStyle, styles } from "./styles";
import { SizeType } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
var Slider = function Slider(props) {
  var _props$primaryColor = props.primaryColor,
    primaryColor = _props$primaryColor === void 0 ? "var(--bds-brand-700-normal,#F7A600)" : _props$primaryColor,
    _props$dotBgColor = props.dotBgColor,
    dotBgColor = _props$dotBgColor === void 0 ? "var(--bds-gray-bg-area)" : _props$dotBgColor,
    className = props.className;
  // const [theme] = useTheme();
  var isRTL = useRTL();
  var defalutMarkWithTrue = props.markTip === undefined ? 'true' : props.markTip.toString();
  var primaryStyles = useMemo(function () {
    return styles(isRTL, primaryColor, dotBgColor);
  }, [dotBgColor, isRTL, primaryColor]);
  return /*#__PURE__*/_jsx(RcSlider, _objectSpread(_objectSpread({}, props), {}, {
    handleRender: props.ToolTip ?
    // @ts-ignore
    function (_node, _props) {
      return handleRender(_node, _props, props.tipFormatter);
    } : undefined,
    prefixCls: "moly-slider",
    className: cn(container, primaryStyles,
    // @ts-ignore
    sizeStyle[props.size || SizeType.small], markStyle[defalutMarkWithTrue], className),
    trackStyle: props === null || props === void 0 ? void 0 : props.trackStyle,
    handleStyle: props === null || props === void 0 ? void 0 : props.handleStyle,
    railStyle: props === null || props === void 0 ? void 0 : props.railStyle,
    dotStyle: props === null || props === void 0 ? void 0 : props.dotStyle,
    activeDotStyle: props === null || props === void 0 ? void 0 : props.activeDotStyle,
    reverse: isRTL
  }));
};
export default Slider;